<template lang="pug">
    ib-application(row, :translations="translations")
        FxQuotes
</template>

<script>
import FxQuotes from './FxQuotes.vue';
    export default {
        components: {
            FxQuotes
        },

        data() {
            return {
                translations: _i18n.translations
            };
        },

        methods: {
        }
    }
</script>

<style lang="less">
</style>
